import Client from '../HttpClient';

const numbatUrl = '/gateway/numbat-api/api/vs/manage-config/sysParameter';
const getLanguageList = (type) => {
	return Client.get(`/admin/api/parameter/list-type/${type}`);
};
const getLanguageListCloud = (merchantId, branchId, type) => {
	return Client.get(`${numbatUrl}/${merchantId}/${branchId}/list-type/${type}`);
};
const updateLanguageList = (val) => {
	return Client.put('/admin/api/parameter/batch', val);
};
const updateLanguageListCloud = (merchantId, branchId, val) => {
	return Client.put(`${numbatUrl}/${merchantId}/${branchId}/batch`, val);
};

export default {
	getLanguageList,
	updateLanguageList,
	getLanguageListCloud,
	updateLanguageListCloud,
};
